import React from "react";
import { CButton, CCol, CRow } from "@coreui/react";
import ReceiptItemForm from "../ReceiptItemForm";
import { useReceiptFormContext } from "../context/ReceiptFormContext";
import { extractArrayErrors } from "../../../models/errors";

export const ReceiptFormItems: React.FC = () => {
  const {
    items,
    currency,
    onItemChange,
    onItemDelete,
    onAddItemClick,
    errors,
  } = useReceiptFormContext();

  const itemErrors = extractArrayErrors("items", errors);

  return (
    <>
      <div className="d-flex align-items-center mb-3">
        <strong style={{ fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>Ítems</strong>
        <span style={{ marginLeft: "8px", background: "#006657", color: "white", borderRadius: "10px", padding: "1px 8px", fontSize: "0.7rem", fontWeight: 700 }}>
          {items.length}
        </span>
      </div>
      {items.map((item, ix) => (
        <CRow key={ix}>
          <CCol>
            <ReceiptItemForm
              currency={currency}
              item={item}
              onDelete={() => onItemDelete(ix)}
              onChange={(item) => onItemChange(ix, item)}
              errors={ix < itemErrors.length ? itemErrors[ix] : {}}
            />
          </CCol>
        </CRow>
      ))}
      <CRow className="mt-3">
        <CCol className="d-flex justify-content-end">
          <CButton
            color="primary"
            variant="outline"
            onClick={onAddItemClick}
            style={{ fontWeight: 600, padding: "7px 18px" }}
          >
            <i className="fa fa-plus mr-2"></i>
            Agregar Ítem
          </CButton>
        </CCol>
      </CRow>
    </>
  );
};
